var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeathStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1316,
    height: 494,
    viewBox: "0 0 1316 494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1316,
    height: 494,
    fill: "url(#paint0_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348 399.53C-119.209 419.712 -461 484.363 -461 561C-461 653.784 39.9934 729 658 729C1276.01 729 1777 653.784 1777 561C1777 468.216 1276.01 393 658 393C563.383 393 471.509 394.763 383.756 398.082C381.909 399.26 380.098 400.453 378.323 401.658L348 402.618V399.53Z",
    fill: "url(#paint1_radial)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -461,
    y: 393,
    width: 2238,
    height: 336
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 658,
    cy: 561,
    rx: 1119,
    ry: 168,
    fill: "url(#paint2_radial)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M658 517.397C817.058 517.397 946 492.708 946 462.252C946 431.796 817.058 407.107 658 407.107C498.942 407.107 370 431.796 370 462.252C370 492.708 498.942 517.397 658 517.397ZM658 516.115C812.726 516.115 938.156 491.999 938.156 462.252C938.156 432.505 812.726 408.389 658 408.389C503.274 408.389 377.844 432.505 377.844 462.252C377.844 491.999 503.274 516.115 658 516.115Z",
    fill: "#424E54"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 658,
    cy: 462.252,
    rx: 254.381,
    ry: 48.7328,
    fill: "url(#paint3_radial)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 658,
    cy: 474.079,
    rx: 225.245,
    ry: 38.9863,
    fill: "url(#paint4_radial)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 658,
    cy: 484.965,
    rx: 7.84436,
    ry: 3.79033,
    fill: "#9CA5A9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 658,
    cy: 484.965,
    rx: 3.36187,
    ry: 1.62443,
    fill: "#879196"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205 512.908C205 569.225 295.945 618.522 417 645.641C346.501 613.555 311.852 565.992 311.852 512.908C311.852 471.099 333.346 432.714 376.921 402.618H348V399.412L388.5 390.435V395.134C397.243 389.841 406.742 384.844 417 380.176C295.945 407.294 205 456.592 205 512.908Z",
    fill: "black",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 380,
    width: 212,
    height: 266
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205 512.908C205 569.225 295.945 618.522 417 645.641C346.501 613.555 311.852 565.992 311.852 512.908C311.852 470.653 333.807 431.896 378.323 401.658L348 402.618V399.412L388.5 390.435V395.134C397.243 389.841 406.742 384.844 417 380.176C295.945 407.294 205 456.592 205 512.908Z",
    fill: "black",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417 645.641C295.945 618.522 234.5 569.225 234.5 512.908C234.5 456.592 300.5 410.313 417 380.176C346.501 412.262 311.852 459.824 311.852 512.908C311.852 565.992 346.501 613.555 417 645.641Z",
    fill: "url(#paint5_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1009.14 494.801C1590.3 500.766 2045.26 521.218 2167.5 547.052C2182.23 553.026 2192.12 559.149 2196.83 565.393C2152.75 595.853 1653.48 620.858 995.611 627.335C983.655 640.576 968.313 653.345 950.339 665.532C1635.65 656.454 2159.68 616.06 2197.78 566.762C2199.25 569.1 2200 571.455 2200 573.824C2200 639.389 1628.35 693.657 883.738 702.898C869.065 709.854 853.64 716.519 837.665 722.862C1604.64 714.202 2200 650.779 2200 573.824C2200 571.309 2199.36 568.807 2198.11 566.322C2199.36 564.559 2200 562.785 2200 561C2200 550.105 2176.29 539.592 2132.23 529.693C1967.49 477.526 1518.34 437.474 960.834 426.671C967.281 432.949 973.299 439.463 978.858 446.19C1391.7 453.583 1743.57 474.951 1962.05 504.168C1745.05 480.492 1396.47 463.133 987.249 456.989C996.025 469.023 1003.37 481.664 1009.14 494.801ZM-50.1328 457.902C-294.019 468.588 -499.887 484.622 -646.053 504.168C-500.862 488.327 -296.762 475.313 -55.0066 466.595C-60.5554 477.622 -64.0507 489.11 -66.2524 500.979C-463.347 510.308 -756.951 527.07 -851.5 547.052C-866.227 553.026 -876.124 559.149 -880.831 565.393C-845.952 589.495 -526.08 610.182 -68.1465 620.976C-66.9404 632.748 -64.9494 644.168 -61.6628 655.163C-527.583 638.16 -852.104 605.163 -881.779 566.762C-883.253 569.1 -884 571.455 -884 573.824C-884 571.309 -883.364 568.807 -882.106 566.322C-883.364 564.559 -884 562.785 -884 561C-884 562.342 -883.117 563.675 -881.377 564.998C-878.431 560.057 -873.029 555.181 -865.287 550.38C-877.601 553.839 -883.996 557.385 -884 560.996C-883.995 550.102 -860.281 539.591 -816.226 529.693C-692.264 490.437 -407.249 458.042 -36.2044 439.808C-41.6891 445.669 -46.2838 451.706 -50.1328 457.902ZM953.804 420.072C1419.43 429.421 1810.23 460.421 2024.14 502.524C1808.69 455.771 1413.8 421.435 943.745 411.4C947.193 414.232 950.547 417.124 953.804 420.072ZM-21.5645 426.327C-24.6567 428.801 -27.5516 431.312 -30.2617 433.858C-319.994 448.818 -557.771 472.928 -708.137 502.524C-556.269 469.567 -315.235 442.781 -21.5645 426.327ZM-45.3286 689.956C-543.295 668.325 -884 624.441 -884 573.824C-884 632.626 -536.385 683.528 -30.2072 708.134C-36.0687 702.289 -41.0668 696.223 -45.3286 689.956ZM-16.9149 719.823C-520.465 694.45 -870.404 641.57 -883.613 580.107C-883.87 581.429 -884 582.755 -884 584.084C-884 655.393 -511.148 716.78 24.5467 744.317C7.9989 736.788 -5.65271 728.598 -16.9149 719.823ZM804.958 735.143C779.678 744.12 753.437 752.309 726.947 759.606C1546.57 755.497 2200 678.485 2200 584.084C2200 582.755 2199.87 581.429 2199.61 580.107C2182.15 661.356 1576.26 727.607 804.958 735.143ZM2200 561C2200 557.387 2193.61 553.84 2181.29 550.38C2189.03 555.181 2194.43 560.057 2197.38 564.998C2199.12 563.675 2200 562.342 2200 561Z",
    fill: "#1D2529"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M-43 411C-43 411 255.5 397.694 345.5 397.694C239.5 415.007 99.5 444.5 79 509C69.1966 539.845 -43 554.5 -43 554.5V411Z",
    fill: "#1D2529"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 157,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 609 173)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 68,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 36,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 623 9)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 904 1)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.5,
    cy: 45.5,
    r: 2.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 13.5,
    r: 2.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 446,
    cy: 100,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 355,
    cy: 228,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 172 17)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 477 41)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 244 9)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 758 33)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 948.5 24.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 603,
    cy: 8,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 346,
    cy: 119,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 247,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113,
    cy: 87,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 272 36)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 39 4)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 577 60)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 858 52)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 1050 42)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 1277 42)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 758,
    cy: 119,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1092,
    cy: 70,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1167,
    cy: 185,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 829,
    cy: 36,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 954,
    cy: 85,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1181,
    cy: 85,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1095,
    cy: 66,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 605.5,
    cy: 67.5,
    r: 2.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1008,
    cy: 27,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1235,
    cy: 27,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1149,
    cy: 8,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 980,
    cy: 66,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1207,
    cy: 66,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1121,
    cy: 47,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1034,
    cy: 8,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1261,
    cy: 8,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 1088 155)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 1163 270)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 926,
    cy: 72,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 621,
    cy: 96,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 707,
    cy: 270,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 88,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 187,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 177,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 1016 165)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 1249 133)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 1275 237)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 998,
    cy: 82,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 693,
    cy: 106,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412,
    cy: 98,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321,
    cy: 226,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 187,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 937.5 142.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 1170.5 110.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1075,
    cy: 58,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 82,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 74,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398,
    cy: 202,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 64,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 870 197)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1144,
    cy: 114,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 839,
    cy: 138,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1072,
    cy: 106,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1147,
    cy: 221,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558,
    cy: 130,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.5,
    cy: 121.5,
    r: 2.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 713 105)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 970 216)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 1203 184)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1044,
    cy: 133,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1119,
    cy: 248,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1277,
    cy: 101,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1191,
    cy: 82,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 739,
    cy: 157,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458,
    cy: 149,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448,
    cy: 272,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 266,
    cy: 139,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 139,
    r: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 558 216)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 224 167)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 487 133)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 362 182)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 271 310)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 107 281)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 710.5 164.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 308 124)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 81 124)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 336 163)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 245 291)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 81 262)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 282 105)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1,
    transform: "matrix(-1 0 0 1 55 105)",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(658.682 1704.61) rotate(-90) scale(1704.61 4309.6)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.755928,
    stopColor: "#C9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785883,
    stopColor: "#2F4B65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A171E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(658 729) rotate(-90) scale(336 2238)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.61388,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835374,
    stopColor: "#B4B9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#68747A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(658 729) rotate(-90) scale(336 2238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9BFC2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(658 510.985) rotate(-90) scale(97.4656 573.002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "white",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(658 513.065) rotate(-90) scale(77.9725 507.372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#B9B9B9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#DADADA",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 330.75,
    y1: 404.542,
    x2: 330.75,
    y2: 484.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1316,
    height: 494,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeathStar);
export default __webpack_public_path__ + "static/media/death-star.3297acba9596730bcf47ff7610bbc021.svg";
export { ForwardRef as ReactComponent };